var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerMaxStation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.12,
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#EE4242"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3043_41717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.77 17.23L29.78 17.22L26.06 13.5L25 14.56L27.11 16.67C26.17 17.03 25.5 17.93 25.5 19C25.5 20.38 26.62 21.5 28 21.5C28.36 21.5 28.69 21.42 29 21.29V28.5C29 29.05 28.55 29.5 28 29.5C27.45 29.5 27 29.05 27 28.5V24C27 22.9 26.1 22 25 22H24V15C24 13.9 23.1 13 22 13H16C14.9 13 14 13.9 14 15V29C14 30.1046 14.8954 31 16 31H22C23.1046 31 24 30.1046 24 29V23.5H25.5V28.5C25.5 29.88 26.62 31 28 31C29.38 31 30.5 29.88 30.5 28.5V19C30.5 18.31 30.22 17.68 29.77 17.23ZM22 20H16V15H22V20ZM28 20C27.45 20 27 19.55 27 19C27 18.45 27.45 18 28 18C28.55 18 29 18.45 29 19C29 19.55 28.55 20 28 20Z",
    fill: "#EE4242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3043_41717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerMaxStation);
export default __webpack_public_path__ + "static/media/43f5c4b2cf12b11bc83a1d706fed42a9fccce09bf0.svg";
export { ForwardRef as ReactComponent };